import useAISearchProgress from '../../api/useAISearchProgress';
import AiSearchProfileDialog from '../AiSearchProfilePopout/AiSearchProfileDialog';
import IdentifiedHeader from './IdentifiedHeader';
import IdentifiedList from './IdentifiedList';
import IdentifiedPageLoadingAnimation from './IdentifiedListLoadingAnimation/IdentifiedListLoadingAnimation';
import { IdentifiedTableContext, useIdentifiedTableContextProvider } from './utils/IdentifiedTableContext';

const IdentifiedPageContent = () => {
    const tableContext = useIdentifiedTableContextProvider();
    const { data, isLoading } = useAISearchProgress();
    const isAiSearching = data?.isInProgress || isLoading;

    return (
        <IdentifiedTableContext.Provider value={tableContext}>
            <AiSearchProfileDialog />
            <IdentifiedHeader />
            {isAiSearching ? <IdentifiedPageLoadingAnimation /> : <IdentifiedList />}
        </IdentifiedTableContext.Provider>
    );
};

export default IdentifiedPageContent;
